import { RuiDocument } from '@roc-digital/rich-ui';
import { UiBlockTemplate } from './types';

const DOCUMENT: RuiDocument = {
  "children": [
    {
      "children": [
        {
          "children": [
            {
              "children": [
                {
                  "children": [
                    {
                      "children": [],
                      "data": {
                        "html": "<h1 class=\"font-[Chivo-ExtraBold] text-3xl tracking-tighter leading-tight text-white !font-chivo !font-extrabold !text-[48px] !leading-10 sm:!text-[26px] md:!text-[36px] mr-2\" style=\"line-height: 1;\"><span style=\"font-size: 36pt;\">Log In or Sign Up to get news that’s the most relevant to you.</span></h1>"
                      },
                      "element": "paragraph"
                    }
                  ],
                  "data": {
                    "alignment": "top-left",
                    "backgroundColor": "none",
                    "direction": "row",
                    "height": "fill",
                    "maxWidth": 600,
                    "width": "fill"
                  },
                  "element": "container"
                }
              ],
              "data": {
                "alignment": "top-left",
                "backgroundColor": "none",
                "direction": "column",
                "height": "fill",
                "minWidth": 0,
                "width": "fill"
              },
              "element": "container"
            },
            {
              "children": [
                {
                  "children": [],
                  "data": {
                    "action": "login",
                    "label": "Login",
                    "size": "md",
                    "url": "",
                    "variant": "outline"
                  },
                  "element": "button"
                },
                {
                  "children": [],
                  "data": {
                    "action": "signup",
                    "label": "Sign Up",
                    "size": "md",
                    "url": "",
                    "variant": "secondary"
                  },
                  "element": "button"
                }
              ],
              "data": {
                "alignment": "middle-right",
                "backgroundColor": "none",
                "direction": "row",
                "gap": 16,
                "height": "fill",
                "width": 200
              },
              "element": "container"
            }
          ],
          "data": {
            "alignment": "middle-center",
            "backgroundColor": "none",
            "borderRadius": 0,
            "direction": "row",
            "height": "fill",
            "marginLeft": 0,
            "marginTop": 0,
            "maxWidth": 1024,
            "paddingLeft": 0,
            "paddingTop": 0,
            "width": "fill"
          },
          "element": "container"
        }
      ],
      "data": {
        "alignment": "middle-center",
        "backgroundColor": "#24aae1",
        "direction": "column",
        "gap": 8,
        "height": "hug",
        "paddingLeft": 20,
        "paddingTop": 20,
        "width": "fill"
      },
      "element": "container"
    }
  ],
  "textTokens": []
}

export const TrendingSignupBannerSmall: UiBlockTemplate = {
  class: 'trending-signup-banner-small',
  label: 'Trending Signup Banner Small',
  description: 'Small banner displayed in trending with a signup CTA.',
  document: DOCUMENT,
  validate: () => null,
  webPreviewUrl: '/trending',
}


